import { ref, computed } from '@vue/composition-api'

export function useColumnVisibility() {
  const hiddenColumnNames = ref(new Set())
  const defaultHiddenColumns = ['indication of change (y/n)', 'hide in publication']

  // Initialize column visibility state
  const initializeColumnVisibility = (headers) => {
    const newHiddenColumns = new Set()
    
    headers.forEach((header) => {
      const normalizedHeader = header && header.toString().toLowerCase()
      if (defaultHiddenColumns.includes(normalizedHeader)) {
        newHiddenColumns.add(normalizedHeader)
      }
    })
    
    hiddenColumnNames.value = newHiddenColumns
  }

  // Toggle column visibility by header name
  const toggleColumnVisibilityByName = (headerName) => {
    const normalizedHeader = headerName && headerName.toString().toLowerCase()
    const newHiddenColumns = new Set(hiddenColumnNames.value)
    
    if (newHiddenColumns.has(normalizedHeader)) {
      newHiddenColumns.delete(normalizedHeader)
    } else {
      newHiddenColumns.add(normalizedHeader)
    }
    
    hiddenColumnNames.value = newHiddenColumns
  }

  // Toggle column visibility by index (for backwards compatibility)
  const toggleColumnVisibility = (columnIndex, headers) => {
    if (headers && headers[columnIndex]) {
      toggleColumnVisibilityByName(headers[columnIndex])
    }
  }

  // Check if column is visible by header name
  const isColumnVisibleByName = (headerName) => {
    const normalizedHeader = headerName && headerName.toString().toLowerCase()
    return !hiddenColumnNames.value.has(normalizedHeader)
  }

  // Check if column is visible by index
  const isColumnVisible = (columnIndex, headers) => {
    if (!headers || !headers[columnIndex]) return true
    return isColumnVisibleByName(headers[columnIndex])
  }

  // Get column visibility stats
  const getColumnStats = (headers) => {
    if (!headers || headers.length === 0) {
      return { total: 0, visible: 0, hidden: 0 }
    }
    
    const visibleCount = headers.filter(header => isColumnVisibleByName(header)).length
    
    return {
      total: headers.length,
      visible: visibleCount,
      hidden: headers.length - visibleCount
    }
  }

  return {
    hiddenColumnNames,
    initializeColumnVisibility,
    toggleColumnVisibility,
    toggleColumnVisibilityByName,
    isColumnVisible,
    isColumnVisibleByName,
    getColumnStats
  }
}
